import React from 'react'
import { ProductLockupMini } from '@src/components/ProductLockupMini/ProductLockupMini'
import { ShareDialogProductDetailsItemProps } from '@src/components/ShareDialog/ShareDialog'
import vrStyles from '@src/styles/utils/vrStyles'
import { makeStyles } from '@material-ui/core/styles'

interface ShareDialogProductDetailsProps {
  itemNumber: string
  product: ShareDialogProductDetailsItemProps
}

const { vr4 } = vrStyles

const useStyles = makeStyles(() => ({
  vr4,
}))

const ShareDialogProductDetails: React.FC<ShareDialogProductDetailsProps> = ({
  product,
  itemNumber,
}) => {
  const classes = useStyles()

  return (
    <>
      <ProductLockupMini
        image={product.productImage}
        productNumber={itemNumber}
        brand={product.brand}
        name={product.productName}
        description={product.productDescription}
      />
      <div className={classes.vr4} />
    </>
  )
}
export default ShareDialogProductDetails
